import React, { useState, useCallback, useEffect } from 'react';
import DriverForm from './DriverForm';
import DriverKillQuestions from './DriverKillQuestions';
import DriverChangeConfirm from './DriverChangeConfirm';
import DriverFields from './DriverFields';
import Conclusion from '../Conclusion';
import ChangedFields from '../ChangedFields';
import moment from 'moment';

const EditAndRateDriver = ({ onSave, onExit, onCancel, save, policy, isAdd, onRate, onRateConfirm, rate, onClearRate }) => {
	const [data, setData] = useState({
		step: 0,
		firstName: '',
		middleInitial: '',
		lastName: '',
		suffix: null,
		dateOfBirth: '',
		gender: 1,
		maritalStatus: null,
		driversLicenseNumber: '',
		stateLicensed: 16,
		licenseStatus: 1,
		relationship: null,
		licensedForThreeOrMoreYears: false,
		isBLevelStudent: false,
		isDriversLicenseValid: null,
		isFullTimeStudent: false,
		studentStatus: null,
		changedFields: isAdd ? ['gender', 'stateLicensed', 'isBLevelStudent'] : [],
		originalDriver: null,
	});

	useEffect(() => {
		if (save) {
			if (save.dateOfBirth != null && save.dateOfBirth !== '') {
				save.dateOfBirth = moment(save.dateOfBirth).toDate();
			}
			setData({ ...data, ...save });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onDriverFormChange = useCallback(
		(_, { name, value }) => {
			const newData = {
				...data, [name]: value, changedFields: [...new Set([...data.changedFields, name])]
			}
			
			if(name === 'dateOfBirth') {
				var driverAge = moment().diff(moment(value), 'years');

				if(driverAge < 16 && driverAge > 25) {
					newData.studentStatus = null;
					newData.isBLevelStudent = false;
				}
			}

			setData(newData);
		},
		[data]
	);

	const onDriverFormContinue = useCallback(async () => {
		try {
			const newData = { ...data, step: 2 };

			setData(newData);
			await onRate(newData);
		} catch (error) {
			console.log('error', error);
		}
	}, [data, onRate]);

	const onChangeComplete = useCallback(async () => {
		try {
			await onRateConfirm();
			setData({ ...data, step: 3 });
		} catch (error) {
			console.log('error', error);
		}
	}, [data, onRateConfirm]);

	const onEdit = useCallback(() => {
		onClearRate();
		setData({ ...data, step: 1 });
	}, [data, onClearRate]);

	const onSaveAndExit = useCallback(() => {
		onSave(data);
		onExit();
	}, [data, onExit, onSave]);

	const onResetStudentStatus = useCallback(() => {
		setData({ ...data, studentStatus: null, isBLevelStudent: false });
	}, [data]);

	switch (data.step) {
		case 1:
			return <DriverForm data={data} onChange={onDriverFormChange} onContinue={onDriverFormContinue} onSaveAndExit={onSaveAndExit} onCancel={onCancel} isAdd={isAdd} onBack={() => setData({ ...data, step: 0 })} agency={policy.agency} onResetStudentStatus={onResetStudentStatus} />;
		case 2:
			return <DriverChangeConfirm data={data} isAdd={isAdd} onSaveAndExit={onSaveAndExit} onComplete={onChangeComplete} onEdit={onEdit} policy={policy} rate={rate} onCancel={onCancel} />;
		case 3:
			return (
				<Conclusion title={isAdd ? 'The addition of the following driver was completed successfully!' : 'The driver information was edited successfully!'} rate={rate} policy={policy} onExit={onExit}>
					<ChangedFields
						data={data}
						changedFields={data.changedFields}
						originalData={data.originalDriver}
						isAdd={isAdd}
						fields={DriverFields}
						other={[
							{ label: isAdd ? 'Driver Added' : 'Driver', text: `${data.firstName} ${data.lastName}` },
						]}
					/>
				</Conclusion>
			);
		default:
			return <DriverKillQuestions onContinue={() => setData({ ...data, step: 1 })} onCancel={onCancel} />;
	}
};

export default EditAndRateDriver;
